const BASE_HOST = process.env.VUE_APP_BASE_HOST;
const MEDIA_HOST = process.env.VUE_APP_MEDIA_HOST;
const FRON_HOST = process.env.VUE_APP_FRON_HOST;

export { BASE_HOST, MEDIA_HOST, FRON_HOST };
